import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { useConfig } from "../../utils/useConfig"
import { getSafeSessionConfig } from "../utils/getSafeSessionConfig";
import { useMutation } from "react-query";
import { toast } from "react-toastify";
import { applyUserTags } from "../../mutations/users/applyUserTags";
import { Employee, TagReference } from "../../models";
import { useData } from "../../utils/useData";

export const useApplyUserTags = (options?: {
    onSuccess?: () => void;
    onError?: (error: Error) => void;
    successMessage?: string;
  }) => {
    const { config } = useConfig();
    const { getToken } = useKindeAuth();
    const { employees, employerId } = useData();

    return useMutation(
        async ({ employees, tags }: { employees: Employee[], tags: TagReference[]}) => {
            const { API_URL, token } = await getSafeSessionConfig(config, getToken);
            let completed = 0;
            let toastId = toast("Assigning Tags...", {
              progress: 0,
              autoClose: false,
              type: "info"
            });
      
            await Promise.all(
                employees.map(async (employee) => {
                    await applyUserTags(API_URL, employerId, token, employee, tags);
                    completed += 1;
                    toast.update(toastId, {
                      progress: completed / employees.length
                    });
                })
            );

            toast.update(toastId, {
                render: "Tags assigned successfully",
                type: "success",
                autoClose: 5000,
                progress: 1
              });
        },
        {
            onSuccess: () => {
                employees.refetch();
                options?.onSuccess?.();
            },
            onError: (error: Error) => {
                toast.error(error.message);
                options?.onError?.(error);
            }
        }
    )
}